<template>
    <div
        v-for="(card, index) in visibleCards"
        :key="index"
        :class="{visible: card.visible}"
    >
        <div class="offerCard offer" v-if="card.visible">
            <div v-if="card.head" v-html="card.head"></div>
            <div v-if="card.text" class="adv" v-html="card.text"></div>
            <div v-if="card.button" class="button" v-html="card.button"></div>

            <div class="closeButton" @click.prevent="closeCard(index)">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <g clip-path="url(#clip0_3073_824)">
                        <path d="M11 1L1 11" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1 1L11 11" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_3073_824">
                            <rect width="12" height="12" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
        </div>
    </div>

</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
    cards: Array,
    params: Object,
});

const visibleCards = ref([]);

const closeCard = (index) => {
    visibleCards.value[index].visible = false
}

onMounted(() => {
    let delay = props.params?.delay ?? 5

    props.cards.forEach((card, index) => {
        let cardDelay = (index > 0 ? delay + 0.8 : delay)

        setTimeout(() => {
            card.visible = true
            visibleCards.value = props.cards.filter((card) => card.visible);
        }, cardDelay * 1000)
    });
});
</script>

<style>

#OfferCards {
    position: fixed;
    width: 320px;
    max-width: 100%;
    bottom: 0;
    right: 0;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 999;
    max-height: 100%;
}

.offerCard {
    opacity: 0;
    transform: translateY(20px);
    height: 0;
    padding: 10px;
    margin: 10px 10px 20px;
    box-shadow: 0 0 10px #e9e9e9;
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    text-align: center;
    font-size: 14px;
    background: #fff;
    transition: opacity 0.3s ease, transform 0.3s ease, height 0.3s ease;
}

.offerCard .head{
    margin: auto;
    width: 150px;
    height: 60px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}
.offerCard img{
    width: auto;
    height: 100%;
}
.offerCard .adv{
    font-weight: 500;
}
.offerCard .adv > div{
    border: none;
}
.offerCard .button a {
    display: flex;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 6px;
    background: var(--color-primary);
    box-shadow: 0 6px 10px 0 rgba(246, 123, 9, 0.20);
    color: #fff;
    text-align: center;
    border: none;
    font-size: 16px;
    font-weight: 500;
    line-height: 120%;
    cursor: pointer;
    font-family: inherit;
    text-decoration: none;
    margin: 10px auto;
}

.offerCard .closeButton {
    cursor: pointer;
    position: absolute;
    top: 15px;
    right: 15px;
}

.offerCard .closeButton svg{
    width: 20px;
    height: 20px;
}

.offerCard:nth-child(1) {
    animation: fadeInUp 0.5s ease 0.3s forwards;
}

.offerCard:nth-child(2) {
    animation: fadeInUp 0.5s ease 0.6s forwards;
}

.offerCard:nth-child(3) {
    animation: fadeInUp 0.5s ease 0.9s forwards;
}

.offerCard:nth-child(4) {
    animation: fadeInUp 0.5s ease 1.2s forwards;
}

.offerCard:nth-child(5) {
    animation: fadeInUp 0.5s ease 1.5s forwards;
}

.offerCard:nth-child(6) {
    animation: fadeInUp 0.5s ease 1.8s forwards;
}

@keyframes fadeInUp {
    to {
        opacity: 1;
        transform: translateY(0);
        height: auto;
    }
}

@media all and (max-height: 450px){
    .offerCard {
        margin: 5px 5px 5px;
    }
    .offerCard .head {
        width: 120px;
        height: 40px;
    }
    .offerCard .promotion {
        font-size: 12px;
    }
    .offerCard .button a {
        padding: 5px;
        font-size: 14px;
    }
    .offerCard .closeButton svg {
        width: 14px;
        height: 14px;
    }
}

</style>
